import type { LoginOrSignupPageData } from '#src/app/pages/loginOrSignup/pageContext';
import { useLoginOrSignupPageData } from '#src/app/pages/loginOrSignup/pageContext';

import { useLoginUserFlow } from '../useLoginUserFlow';

type Result = ModelHookResult<{
	experiment: LoginOrSignupPageData['experiments']['loginOrJoinSapCyclingProof'];
	isSapVisitor: boolean;
	isTreatment: boolean;
}>;

/**
 * Single source of truth for the `login_or_join_sap_cycling_proof` experiment on this page.
 *
 * `isSapVisitor` is relevance (client-side URL state the experimentation platform cannot target),
 * so it gates the subtree rather than the exposure tracker; `isTreatment` is the only branch
 * consumers should read for the V3d experience.
 */
export function useSapCyclingProofExperiment(): Result {
	const { data: pageData } = useLoginOrSignupPageData();
	const userFlow = useLoginUserFlow();

	const experiment = pageData.experiments.loginOrJoinSapCyclingProof;
	const isSapVisitor = userFlow === 'sap';

	return {
		data: {
			experiment,
			isSapVisitor,
			isTreatment: isSapVisitor && experiment.variation === 'variation_1',
		},
	};
}
